<template>
  <v-dialog :value="open" min-width="640px" :max-width="cardWidth" :persistent="persistent" :fullscreen="fullscreen" @click:outside="handleClickOutside">
    <v-card>
      <div class="dialog-actions">
        <v-btn text icon @click="fullscreen = !fullscreen">
          <v-icon v-if="fullscreen">mdi-window-restore</v-icon>
          <v-icon v-else>mdi-window-maximize</v-icon>
        </v-btn>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="px-8 pt-8 pb-4" :class="headerColor">
        <slot name="title"/>
      </div>
      <div class="ma-8">
        <slot />
      </div>
      <v-card-actions class="pb-8">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    open: {
      type: Boolean,
      required: true
    },
    headerColor: {
      type: String,
      default: undefined
    },
    persistent: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: undefined,
    },
    canFullscreen: {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    return {
      fullscreen: false
    }
  },
  computed: {
    cardWidth () {
      return this.width ? this.width : "960px";
    },
  },
  methods: {
    handleClickOutside() {
      if (!this.persistent) {
        this.$emit("close")
      }
    }
  }
}
</script>

<style scoped>
.dialog-actions {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
